class SharedLinkScreenController {

    constructor() {
        this.sharedLinks = null;
        this.moreLinks = true;
        this.batchSize = 10;
        this.offset = 0;
        this.lastScroll = 0;
    }

    draw(document, scroll=false) {
        let that = this;

        // Paginacion. Si no hay mas links, no hacer la peticion
        if(that.moreLinks) {
            this.offset = this.sharedLinks && this.sharedLinks.length > 0 ? this.offset+this.batchSize : 0;
            api.getSharedLinks(document.id, that.offset, that.batchSize).done(function (response) {
                if (response.result.length < that.batchSize) {
                    that.moreLinks = false;
                }
                that.sharedLinks = that.sharedLinks ? that.sharedLinks.concat(response.result) : response.result;
                that.drawList(document, response.result);
            });
        } else if (!scroll) {
            that.drawList(document, that.sharedLinks);
        }
    }

    drawList(document) {
        let that = this;
        that.sharedLinks = that.formatedSharedLinks(that.sharedLinks);

        let template = Handlebars.compile($("#sharedLinkScreen").html());
        $('#shareInputGroup').html(template({
            sharedLinks: that.sharedLinks,
            world: world,
            sharedIcon: customIcons["DOCUMENTATION_BOTTOM_NAVIGATION_SHARE"],
            editIcon: customIcons["DOCUMENTATION_SHARE_DOC_EDIT"],
            deleteIcon: customIcons["DOCUMENTATION_SHARE_DOC_DELETE"]
        }));

        $(document).ready(function () {
            that.manageSections(that.sharedLinks);
            that.drawSharedTime(world.share_times[1].id);
            $('.num-days').each(function () {
                let days = $(this).data('days');
                $(this).css('color', that.getDaysColor(days));
            });

            // Paginación. Mantener la posicion del scroll luego de pedir los links
            // $('.listLinkItems').niceScroll();
            // if($('.listLinkItems').getNiceScroll())
            //     $('.listLinkItems').getNiceScroll()[0].scrollTop(that.lastScroll);

            if(that.lastScroll) {
                window.scrollTo(0, that.lastScroll);
            }
        });

        // Guardar (crear/editar)
        $('#shareButton').on('click', function (e) {
            let shareName = $('#linkName').val();
            let shareTimeId = $('.shareTimeBtn.selected').data('id');

            if (shareName !== '' && shareTimeId !== undefined) {
                api.createSharedLink(shareTimeId, shareName, document.id, $(this).data('link-id'), function (responseLink) {
                    responseLink = responseLink.result;
                    let index = _.findIndex(that.sharedLinks, {share_link_id: responseLink.share_link_id});

                    if (index >= 0) { // EDITAR
                        // Actualizar el enlace editado en el listado
                        that.formatedSharedLink(responseLink);
                        that.sharedLinks.splice(index, 1, responseLink);
                    } else { // CREAR
                        // Si no hay mas links que cargar, añadir el link al final del listado.
                        if (!that.moreLinks) {
                            that.formatedSharedLink(responseLink);
                            that.sharedLinks.push(responseLink);
                        }
                    }
                    
                    that.drawList(document);
                    that.manageSections(that.sharedLinks);

                    // Guardar que el documento ha sido compartido para mostrar los iconos de shared de rojo
                    document.is_shared=true;
                });
            }
        });

        // Editar
        $('.editLinkBtn').on('click', function (e) {
            $('.listLinks').hide();
            $('.editLinkForm').show();

            let linkId = $(this).data('id');
            let link = _.filter(that.sharedLinks, function (sharedLink) { return sharedLink.share_link_id === linkId })[0];

            // Info extra dias y visitas
            let expirationDate = moment(link.share_link_expiration_date, 'DD-MM-YYYY');
            let now = moment();
            let days = expirationDate.diff(now, 'days')+1;
            $('.shareDays').text(sprintf(Translator.trans(days !== 1 ? 'TR_DIAS' : 'TR_DIA'), days));
            $('.shareDays').css('background-color', that.getDaysColor(days));
            $('.shareVisits').text(sprintf(Translator.trans(link.share_link_views !== 1 ? 'TR_VISITAS' : 'TR_VISITA'), link.share_link_views));

            // Si el link no tiene tiempo es indefinido
            link.share_link_time === null ? link.share_link_time = 4 : link.share_link_time;

            $('#linkName').val(link.share_link_name);

            that.drawSharedTime(link.share_link_time);
            that.disableSharedBtn();

            $('#shareButton').attr('data-link-id', linkId);
            $('#shareButton').text(Translator.trans('TR_ACTUALIZAR_ENLACE'));
        });

        // Borrar
        $('.deleteLinkBtn').on('click', function (e) {
            let linkId = $(this).data('id');
            api.deleteShareDocument(linkId, function (deleted) {
                that.sharedLinks = _.filter(that.sharedLinks, function (sharedLink) { return sharedLink.share_link_id !== linkId});
                that.drawList(document);

                // Mirar si todavia quedan links. Si no quedan links, actualizar el array de documentos
                if (that.sharedLinks.length === 0) {
                    let currentFolder = documentationScreenController.getCurrentFolder();
                    document.is_shared=false;

                    $('.bottomDisplayedSection').hide();
                    $('.share-document').toggleClass('world_color_1_bg');
                    let advancedShareButton = $('#documentShare-' + document.id + '-advanced-' + currentFolder.id);
                    if (advancedShareButton.length) {
                        advancedShareButton.closest(".bottomOptionSelected").removeClass('world_color_1_bg');
                    }
                    $('.shareSelectedBorder').css('background-color', 'transparent');
                }
            });
        });

        // Al clicar el btn para crear un nuevo enlace
        $('.showCreateLinkForm').on('click', function (e) {
            $('.listLinks').hide();
            $('.editLinkForm').show();
            $('.extraInfo').hide();
            $('.shareTimeBtn[data-id="1"]').trigger('click');

            that.disableSharedBtn();
        });

        // Habilitar y desabilitar el boton de compartir
        $('#linkName').on("keyup", function (e) {
            that.disableSharedBtn();
        });

        // Copiar la url en el portapapeles
        $('.shareLinkBtn').on('click', function (e) {
            that.createClipboardButton();
        });

        // Modificar el estilo de los botones de tiempo de caducidad del enlace
        $(".shareTimeBtn").on('click', function (e) {
            let clickedTimeId = $(this).data('id');
            that.drawSharedTime(clickedTimeId)
        });

        // Paginación
        $('.listLinkItems').scroll(function (e) {
            that.lastScroll = window.scrollY;

            if($('.listLinkItems').innerHeight() + window.scrollY >= $('.listLinkItems')[0].scrollHeight) {
                that.draw(document, true);
            }
        });
    }

    // Mostrar/Ocultar las secciones
    manageSections(sharedLinks) {
        if(sharedLinks) {
            if (sharedLinks.length === 0) {
                $(".listLinks").hide();
                $(".extraInfo").hide();
                $(".editLinkForm").show();
            } else {
                $(".editLinkForm").hide();
                $(".listLinks").show();
            }
        }
    }

    formatedSharedLinks(sharedLinks){
        let that = this;
        _.map(sharedLinks, function (sharedLink) { that.formatedSharedLink(sharedLink); });
        return sharedLinks;
    }

    formatedSharedLink(sharedLink){
        if(!sharedLink.share_link_name) {
            sharedLink.share_link_name = '--';
        }

        if(sharedLink.share_link_expiration_date) {
            let expirationDate = moment(sharedLink.share_link_expiration_date, 'DD-MM-YYYY');
            let now = moment();
            let days = expirationDate.diff(now, 'days')+1;
            let expirationDays = '';

            if(days <= 7) {
                expirationDays = sprintf(Translator.trans(days !== 1 ? 'TR_DIAS' : 'TR_DIA'), days);
            } else if (days < 30) {
                expirationDays = sprintf(Translator.trans(Math.round(days/7) !== 1 ? 'TR_SEMANAS' : 'TR_SEMANA'), Math.round(days/7));
            } else {
                expirationDays = sprintf(Translator.trans(Math.round(days/30) !== 1 ? 'TR_MESES' : 'TR_MES'), Math.round(days/30));
            }

            sharedLink.share_link_expiration_days_text = expirationDays;
            sharedLink.share_link_expiration_days = days;
        } else {
            sharedLink.share_link_expiration_days_text = Translator.trans("TR_INDEFINITE");
        }

    }

    createClipboardButton(){
        this.clipboardItem = new Clipboard('.shareLinkBtn', {
            text: function(trigger) {
                return trigger.getAttribute('aria-label');
            }
        });

        this.clipboardItem.on('success', function(e) {
            $(".shareLinkBtn").css("pointer-events", "none");

            $('#tooltipShareCompleted').tooltip({
                placement: 'top',
                trigger: 'manual'
            }).tooltip('open');

            setTimeout(function () {
                $('#tooltipShareCompleted').tooltip('destroy');
                $(".shareLinkBtn").css("pointer-events", "auto");
            }, 1500);
        });
    }

    getDaysColor(days) {
        if(!days) {
            return '#44daff';
        } else if(days < 15) {
            return '#d93f48';
        } else {
            return '#94d372';
        }
    }

    // Desabilitar el btn de actualizar/crear link
    disableSharedBtn() {
        if($('#linkName').val().length === 0) {
            $('#shareButton').addClass('disabled');
        } else {
            $('#shareButton').removeClass('disabled');
        }
    }

    drawSharedTime(clickedTimeId) {
        let color1 = hex2rgba(world.theme.color_1, 1);
        let rgbaColor = color1.match(/^rgba\((\d+),\s*(\d+),\s*(\d+),\s*(\d+)\)$/);
        let rgbaColorSlice = rgbaColor.slice(1, 4);
        let rgb = rgbaColorSlice.join(',');
        $(".shareTimeBtn").each(function () {
            let otherTimeId = $(this).data('id');
            if(clickedTimeId !== otherTimeId) {
                $(this).css('border', '1px solid rgb(' + rgb + ')');
                $(this).css('box-shadow', 'none');
                $(this).css('background-color', 'white');
                $(this).css('color', 'rgb(' + rgb + ')');
                $(this).removeClass('selected');
                tintImage($(this).find('canvas').attr('id'), $(this).find('canvas').attr('data-icon'),  world.theme.color_1);
            } else {
                $(this).css('border', '1px solid rgb(' + rgb + ')');
                $(this).css('box-shadow', 'rgba(' + rgb + ', 0.6) 0px 0px 0px 4px');
                $(this).css('background-color', 'rgba(' + rgb + ')');
                $(this).css('color', 'white');
                $(this).addClass('selected');
                tintImage($(this).find('canvas').attr('id'), $(this).find('canvas').attr('data-icon'),  'FFFFFF');
            }
        })
    }
}